import { Link } from 'gatsby';
import React from 'react';
import classNames from 'classnames';
import './style.scss';

function Button({ text, link, dark = false }) {
  return (
    <Link
      className={classNames({ 'cta-btn__container': true, 'dark': dark })}
      to={link}
    >
      {text}
    </Link>
  );
}

export default Button;
